
export function calcRibbonRollsNeededPreview(input: {
  labelLength: number
  labelGap: number
  labelsPerRoll: number
  labelRollsCount: number
  ribbonLength: number
}): number {
  const labelLength = Number(input.labelLength) || 0
  const labelGap = Number(input.labelGap) || 0
  const labelsPerRoll = Number(input.labelsPerRoll) || 0
  const labelRollsCount = Number(input.labelRollsCount) || 0
  const ribbonLength = Number(input.ribbonLength) || 0

  if (ribbonLength <= 0) return 0

  const raw =
    ((labelLength + labelGap) * labelsPerRoll * labelRollsCount) / 1000 / ribbonLength

  return Math.round(raw) + 1
}

export function calcRibbonProfitPreview(costPrice: number, sellPrice: number): number {
  return Math.round(((Number(sellPrice) || 0) - (Number(costPrice) || 0)) * 100) / 100
}
